import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isAuth: false,
    userInfo: null,
}

export const authSlice = createSlice({
    name: 'auth-user',
    initialState,
    reducers: {
        loginUser: (state, action) => {
            const user = action.payload
            localStorage.setItem('userInfo', JSON.stringify(user))
            state.userInfo = action.payload
            state.isAuth = true
        },
        logoutUser: (state) => {
            localStorage.removeItem('userInfo')
            state.userInfo = null
            state.isAuth = false
        },
    },
})

export const { loginUser, logoutUser } = authSlice.actions
export default authSlice.reducer
